import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'church-details-times',
  templateUrl: './church-details-times.component.html',
  styleUrls: ['./church-details-times.component.scss'],
})
export class ChurchDetailsTimesComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
